import BaseState from "@state/BaseState";
import { Signals } from "@/Imports";
import GameStatesEnum from "../GameStatesEnum";

export default class IdleState extends BaseState {
  begin() {
    this.model.stateSkippedWinnings = false;
    if (this.model.stateSkipped && !this.model.isFreespinsMode) {
      this.model.stateSkipped = false;
      this.end();
      return;
    }
    if (this.model.isAuto || this.model.isFreespinsMode) {
      this.end();
    } else {
      if (!this.model.isFreespinsMode) {
        console.log("SPIN BUTT PRESS");
        Signals.spinBtnPressed.addOnce(this.end, this);
      }
    }
    Signals.buyBtnPressed.add(this.endBuy, this);
  }

  end = () => {
    let gameState = GameStatesEnum.PRE_SPIN_START;
    this.stateMachine.setState(gameState);
  };

  endBuy = () => {
    let gameState = GameStatesEnum.GET_BUY_FREESPIN_RESPONSE;
    this.stateMachine.setState(gameState);
  };

  cleanUp() {
    if (!this.model.isFreespinsMode) {
      Signals.spinBtnPressed.remove(this.end, this);
    }
    Signals.buyBtnPressed.remove(this.endBuy, this);
  }
}
